import { useEffect, useState } from "react";
import styled from "styled-components";
import LoadingSpinner from "./misc/LoadingSpinner";
import Warning from "./Svg/Warning";

const NoMobileWrapper = styled.main`
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 3rem;

  & p {
    font-size: 20px;
    line-height: 30px;
  }
`;

const LOADING_TIMEOUT = 500;

const NoMobile = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, LOADING_TIMEOUT);
  }, []);

  if (loading) return <LoadingSpinner size="lg" />;
  return (
    <NoMobileWrapper>
      <Warning />
      <h1>Isso ainda não está pronto</h1>
      <p>
        Estamos trabalhando na melhor experiência para gerir as finanças no seu
        dispositivo móvel.
      </p>
    </NoMobileWrapper>
  );
};

export default NoMobile;
